import { ToTuple } from '../../types/helpers';

export const splitArrayByMaxLength = <T>(
  entries: T[],
  maxLength: number,
): T[][] => {
  const parts = Math.ceil(entries.length / maxLength);
  const iterArray = new Array(parts).fill(0);
  return iterArray.map((_, index) => {
    const begin = maxLength * index,
      end = maxLength * (index + 1);
    return entries.slice(begin, end);
  });
};

/** If passed argument is an array, return unchanged. Otherwise, return a single element array. */
export const returnAsArray = <T>(arg: T | T[]): T[] =>
  Array.isArray(arg) ? arg : [arg];

/** Filter an array for defined and non-null elements only */
export const definedArrayFilter = <T>(
  arg: readonly (T | undefined | null)[],
  // Assertion needed for use in strictly typed libraries.
): T[] => arg.filter((arg) => arg !== null && arg !== undefined) as T[];

export const randomPick = <T>(arg: readonly T[]): T =>
  arg[Math.floor(Math.random() * arg.length)];

export const toTuple = <T extends readonly unknown[]>(args: T) =>
  args as ToTuple<T>;
